import React, { useState } from 'react';
import { Form, Input, Button, Alert } from 'antd';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Slide 1 : Vérification de l'email
 * - Saisie email + confirmation
 * - Appel API pour vérifier si user existe
 * - Stocke userExists dans le state parent
 */
const StepEmail = ({ onNext, membershipCode, companyName }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      setError(null);

      // Vérifier si l'utilisateur existe
      const response = await axios.post(`${BACKEND_URL}/api/register/check-user-exists`, {
        email: values.email,
      });

      // Passer les données au parent avec l'info si user existe
      onNext({
        email: values.email,
        userExists: response.data.exists,
      });
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.data?.[0] || 'Erreur lors de la vérification de l\'email');
      } else if (err.name === 'ValidationError') {
        // Erreur de validation du formulaire, ne rien faire (Ant Design affiche déjà les erreurs)
      } else {
        setError('Erreur de connexion au serveur');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="step-email">
      <Alert
        message={`Inscription - ${companyName}`}
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      <h3>Étape 1 : Vérification du compte</h3>
      <p>Veuillez saisir votre adresse email professionnelle.</p>

      {error && (
        <Alert
          message="Erreur"
          description={error}
          type="error"
          closable
          onClose={() => setError(null)}
          style={{ marginBottom: 16 }}
        />
      )}

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label="Email professionnel"
          name="email"
          rules={[
            { required: true, message: 'L\'email est requis' },
            { type: 'email', message: 'Veuillez saisir un email valide' },
          ]}
        >
          <Input
            size="large"
            disabled={loading}
          />
        </Form.Item>

        <Form.Item
          label="Confirmation de l'email"
          name="email2"
          dependencies={['email']}
          rules={[
            { required: true, message: 'Veuillez confirmer votre email' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('email') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Les emails ne correspondent pas'));
              },
            }),
          ]}
        >
          <Input
            placeholder="Confirmez votre email"
            size="large"
            disabled={loading}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={loading}
            block
          >
            Suivant
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default StepEmail;
